module.exports = __webpack_public_path__ + "img/health-status-bad.b9dcd549.svg";